import $ from 'jquery';
import { handleSmile } from './index';

export default function initSmileListeners() {
  $('body').on('click', '#editor-menu-image-smile', handleSmile);
}
